import { ContentChild, Directive, Input } from "@angular/core";
import { KzAccordionContent } from "./kz-accordion-content.directive";
import { KzAccordionHeader } from "./kz-accordion-header.directive";
import { KzAccordionTitle } from "./kz-accordion-title.directive";
import { AccordionContext } from '../accordion-options';

@Directive({
  selector: "kz-accordion-item",
})
export class KzAccordionItem {
  private _accordionItemContext: AccordionContext = 'default';

  get accordionItemContext(): AccordionContext {
    return this._accordionItemContext;
  }

  @Input()
  set accordionItemContext(value: AccordionContext) {
    this._accordionItemContext = value;
  }
  @Input() title = "";
  @Input() disabled = false;
  @ContentChild(KzAccordionContent) content: KzAccordionContent;
  @ContentChild(KzAccordionTitle) customTitle: KzAccordionTitle;
  @ContentChild(KzAccordionHeader) customHeader: KzAccordionHeader;
}
